import React, { useState, useEffect, useRef } from 'react';
import './ChatInput.css';

const PLACEHOLDERS = [
  "What's bothering you today?",
  "Describe your symptoms...",
  "How can I help you feel better?",
  "Tell me about your health concern...",
];

interface ChatInputProps {
  onSubmit: (message: string) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSubmit }) => {
  const [message, setMessage] = useState('');
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setPlaceholderIndex(prev => (prev + 1) % PLACEHOLDERS.length);
        setIsFading(false);
      }, 250);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSubmit(message);
      setMessage('');
    }
  };

  return (
    <div className="chat-input-container">
      <div className="chat-input-wrapper">
        <form onSubmit={handleSubmit}>
          <div className="textarea-container">
            {!message && (
              <div className={`placeholder-overlay ${isFading ? 'fading' : ''}`}>
                {PLACEHOLDERS[placeholderIndex]}
              </div>
            )}
            <textarea
              ref={textareaRef}
              className="chat-input"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={3}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmit(e);
                }
              }}
            />
          </div>
          <button type="submit" className="send-button" disabled={!message.trim()}>
            <i className="fa-solid fa-paper-plane send-icon" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatInput;
